import React, { useEffect, useState } from 'react';
import { useMingo } from '../context/MingoContext';
import VisaExpiryOverlay from './VisaExpiryOverlay';
import InstallBanner from './InstallBanner';
import LoginModal from './LoginModal';
import CookieConsentBanner from './CookieConsentBanner';

/** 전역 토스트 + 로그인 모달 + 비자 만료 알림 + PWA 설치 안내 */
function AppOverlays() {
  const { toastMessage, loginModalOpen, t } = useMingo();
  const [online, setOnline] = useState(() => (typeof navigator !== 'undefined' ? navigator.onLine : true));

  useEffect(() => {
    function up() {
      setOnline(navigator.onLine);
    }
    window.addEventListener('online', up);
    window.addEventListener('offline', up);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', up);
    };
  }, []);

  return (
    <>
      {!online ? (
        <div className="mingo-offline-banner" role="alert">
          {t('errors.offlineBanner')}
        </div>
      ) : null}
      <InstallBanner />
      <CookieConsentBanner />
      <VisaExpiryOverlay />
      {toastMessage && (
        <div className={`mingo-toast mingo-toast--${toastMessage.type || 'info'}`} role="status">
          {toastMessage.message || ''}
        </div>
      )}
      {loginModalOpen ? <LoginModal /> : null}
    </>
  );
}

export default AppOverlays;
